// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e6ca178d","703":"d72e4131","787":"972c16f2"}[chunkId] + ".chunk.js";
};